import { defineMessages } from "react-intl";

export const commonTooltipMessages = defineMessages({
  noFilterSelected: {
    id: "zyXcBP",
    defaultMessage:
      "Sorting by this column requires active filter: {filterName}",
  },
});
